<!-- eslint-disable max-len -->
<template>
  <img
    v-if="!brand"
    src="@/assets/img/brands/logo_no_brand_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'ridley' && type === 'normal'"
    src="@/assets/img/brands/logo/ridley_full.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'ridley' && type === 'noname'"
    src="@/assets/img/brands/logo/ridley.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'aeres' && type === 'normal'"
    src="@/assets/img/brands/logo/aeres_full.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'aeres' && type === 'noname'"
    src="@/assets/img/brands/logo/aeres.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'nukeproof' && type === 'normal'"
    src="@/assets/img/brands/logo/nukeproof_full.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'nukeproof' && type === 'noname'"
    src="@/assets/img/brands/logo/nukeproof.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="['eddy merckx', 'merckx'].includes(brand.toLowerCase()) && type === 'normal'"
    src="@/assets/img/brands/logo/merckx_full.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="['eddy merckx', 'merckx'].includes(brand.toLowerCase()) && type === 'noname'"
    src="@/assets/img/brands/logo/merckx.svg"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'merckx' && type === 'normal'"
    src="@/assets/img/brands/logo/merckx_full.svg"
    alt="Logo"
    loading="lazy"
  >

  <img
    v-else-if="brand.toLowerCase() === 'merckx' && type === 'noname'"
    src="@/assets/img/brands/logo/merckx.svg"
    alt="Logo"
    loading="lazy"
  >

  <img
    v-else-if="brand.toLowerCase() === 'hjc'"
    src="@/assets/img/brands/logo_hjc_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'sram'"
    src="@/assets/img/brands/logo_sram.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'forza'"
    src="@/assets/img/brands/logo_forza_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'look'"
    src="@/assets/img/brands/logo_look_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'shimano'"
    src="@/assets/img/brands/logo_shimano_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'campagnolo'"
    src="@/assets/img/brands/logo_campagnolo.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'elite'"
    src="@/assets/img/brands/logo_elite_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'fsa'"
    src="@/assets/img/brands/logo_fsa_small.png"
    alt="Logo"
    loading="lazy"
  >
  <img
    v-else-if="brand.toLowerCase() === 'lazer'"
    src="@/assets/img/brands/logo_lazer_small.png"
    alt="Logo"
    loading="lazy"
  >
  <span
    v-else
    class="text-brand"
  >{{ brand }}</span>
</template>
<script>
export default {
  name: 'BrandLogo',
  props: {
    brand: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'normal',
    },
  },
};
</script>
<style scoped>
.text-brand {
  line-height: 15px;
  padding: 2.5px;
  margin-left: 6px;
}
</style>
